// extracted by mini-css-extract-plugin
module.exports = {"user-layout-subtitle":"style_user-layout-subtitle__yHjjZ"};